import { render } from "./TrainingRncpWorkflowComponent.vue?vue&type=template&id=1b967a37&scoped=true"
import script from "./TrainingRncpWorkflowComponent.vue?vue&type=script&lang=js"
export * from "./TrainingRncpWorkflowComponent.vue?vue&type=script&lang=js"

import "./TrainingRncpWorkflowComponent.vue?vue&type=style&index=0&id=1b967a37&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b967a37"]])

export default __exports__